import { Directive, EventEmitter, Input, Output } from '@angular/core';
@Directive()
export abstract class WaitScreenBaseComponent {
  @Input() imagePath? = '~/assets/shared/images/connection_lost.png';
  @Output() backBtnTapped: EventEmitter<boolean> = new EventEmitter();
  @Input() type: string;
}
